import axios from "../utils/axios";

export const getPlantList = () => {
    return axios.get(`Plant/GetList`);
};

export const addPlant = (data) => {
    return axios.post(`/Plant/Add`, data);
};

export const updatePlant = (data) => {
    return axios.post(`/Plant/Update`, data);
};

export const deletePlant = (payload) => {
    return axios.post(`/Plant/Delete`, payload);
};
